module.exports = __webpack_public_path__ + "img/refund_report.a0d337d7.png";